import { render, staticRenderFns } from "./IsolationContent.vue?vue&type=template&id=71c779e9&scoped=true&"
import script from "./IsolationContent.vue?vue&type=script&lang=js&"
export * from "./IsolationContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c779e9",
  null
  
)

export default component.exports